import { queryClient, useApiMutation } from 'theSource/utils';
import { ResponseDto, ErrorResponseDto } from 'theSource/types';
import { useToastDialog } from 'enrollment/components/Shared/ToastDialogContext';
import {
  DecisionIQSurveySubmissionDto,
  DECISION_IQ_SURVEY_SUBMIT_KEY,
  DECISION_IQ_SURVEY_QUERY_KEY,
} from '../useDecisionIQSurveyQuery';
import { GET_BENEFIT_PLANS_QUERY_KEY } from '../useBenefitPlansQuery/utils';

export const DecisionIQMutation = (
  orgBenefitId: number,
  apiHost: string,
  dependentIds?: number[],
  reloadPlans?: boolean
) => {
  const toast = useToastDialog();
  const { isLoading: isLoadingSubmission, mutate: SurveyResponsesRequest } =
    useApiMutation<
      ResponseDto,
      ErrorResponseDto,
      DecisionIQSurveySubmissionDto
    >({
      queryKey: DECISION_IQ_SURVEY_SUBMIT_KEY,
      method: 'put',
      endpoint: `${apiHost}/v1/self_service/decision_support/${orgBenefitId}`,
      queryKeysToInvalidate: DECISION_IQ_SURVEY_QUERY_KEY,
      getErrorMessage: (error) => error.response?.data?.details,
      showSuccessSnackbar: false,
      toastRef: toast,
      onSuccess: () => {
        queryClient.invalidateQueries(
          `${DECISION_IQ_SURVEY_QUERY_KEY}_${orgBenefitId}`
        );
        if (reloadPlans) {
          queryClient.invalidateQueries(
            [
              GET_BENEFIT_PLANS_QUERY_KEY + '-' + orgBenefitId,
              dependentIds ? dependentIds.toString() : '',
            ]
          );
        }
      },
    });

  return { isLoadingSubmission, SurveyResponsesRequest };
};
